import classNames from 'classnames';

import LinkToProfile from './LinkToProfile';
import NextClubPackage from './NextClubPackage';

const ClubSummary = (props) => {
  const {
    club,
    clubPackage,
    clubMembership,
    isSummaryVisibleOnMobile,
    page,
    settings
  } = props;
  return (
    <section
      className={classNames(
        'c7-checkout-summary',
        isSummaryVisibleOnMobile && 'c7-visible'
      )}
    >
      <h2>{club.title}</h2>
      {renderContent(club, page, clubPackage)}
      {!clubPackage && clubMembership && (
        <LinkToProfile clubMembership={clubMembership} />
      )}
      {clubPackage && (
        <NextClubPackage
          clubPackage={clubPackage}
          clubMembership={clubMembership}
          settings={settings}
        />
      )}
    </section>
  );
};

export default ClubSummary;

const renderContent = (club, page, clubPackage) => {
  // Only render content on the signup or on the receipt if package doesnt exist
  if (page === 'Signup' || !clubPackage) {
    return <div dangerouslySetInnerHTML={{ __html: club.content }} />;
  }
  return null;
};
